import * as React from 'react';
import { Dialog as RDialog, DialogContent, DialogFooter, DialogHeader } from './@radix-styled';
import { DialogProps } from '@radix-ui/react-dialog';

interface Props extends DialogProps {
  children:
    | (React.ReactElement<typeof DialogHeader> | React.ReactElement<typeof DialogFooter> | null)[]
    | React.ReactNode;
  className?: string;
  fullScreen?: boolean;
  preventClickOutside?: boolean;
  containerClassName?: string;
  showClose?: boolean;
}

const Dialog: React.FC<Props> = props => {
  const {
    defaultOpen,
    open,
    onOpenChange,
    children,
    modal,
    className,
    fullScreen = true,
    preventClickOutside = false,
    containerClassName,
    showClose = true
  } = props;

  // if dialog is open prevend body scrolling
  React.useEffect(() => {
    if (open) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }

    return () => document.body.classList.remove('overflow-hidden');
  }, [open]);

  return (
    <RDialog {...{ defaultOpen, open, onOpenChange, modal, fullScreen }}>
      <DialogContent
        fullScreen={fullScreen}
        className={className}
        containerClassName={containerClassName}
        showClose={showClose}
        {...(!preventClickOutside && { onOpenChange })}
      >
        {children}
      </DialogContent>
    </RDialog>
  );
};

export default Dialog;
